// src/pages/AuthCallback.jsx
import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

const font = { mono: '"JetBrains Mono", monospace' };

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const { setAuthToken, setIsLoggedIn, setAdminUser, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Token is in the URL fragment (#token=...) to keep it out of server logs
    const hash   = window.location.hash.slice(1);
    const params = new URLSearchParams(hash);
    const token  = params.get('token');
    const error  = searchParams.get('error');

    if (error || !token) {
      logout();
      navigate('/');
      return;
    }

    // Verify the token is actually an admin
    fetch(`${BACKEND_URL}/api/admin/check`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => {
        if (!r.ok) throw new Error('Not authorized');
        return r.json();
      })
      .then(data => {
        if (!data.is_admin) throw new Error('Not an admin account');
        localStorage.setItem('bgn_admin_token', token);
        setAuthToken(token);
        setIsLoggedIn(true);
        setAdminUser(data);
        navigate('/admin');
      })
      .catch(() => {
        logout();
        navigate('/?error=not_admin');
      });
  }, []);

  return (
    <div style={{ background: '#000', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div style={{ textAlign: 'center' }}>
        <div style={{ width: 36, height: 36, border: '2px solid #222', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 1rem' }} />
        <p style={{ fontFamily: font.mono, fontSize: '0.7rem', color: '#555', letterSpacing: '0.1em' }}>VERIFYING ADMIN ACCESS...</p>
      </div>
    </div>
  );
};

export default AuthCallback;